import { FeatureKey, type StudioModuleProfile } from './types';
import { FEATURE_REGISTRY } from './registry';

export type { StudioModuleProfile };
const SOCIAL_COMMERCE_MODULES: ReadonlySet<FeatureKey> = new Set([
  FeatureKey.CIRCLES,
  FeatureKey.COURSES,
  FeatureKey.EVENTS,
  FeatureKey.MEMBERSHIPS,
  FeatureKey.OFFERS,
]);

export function getStudioModuleProfile(key: FeatureKey): StudioModuleProfile {
  const feature = FEATURE_REGISTRY[key];
  if (feature.studioBacklog) {
    return 'backlog';
  }
  if (feature.moduleProfile) {
    return feature.moduleProfile;
  }
  if (SOCIAL_COMMERCE_MODULES.has(key)) {
    return 'social-commerce';
  }
  if (feature.creatorOverrideable) {
    return 'studio-only';
  }
  return 'studio-only';
}

export function isSocialCommerceModule(key: FeatureKey): boolean {
  return getStudioModuleProfile(key) === 'social-commerce';
}

export function listSocialCommerceModules(): FeatureKey[] {
  return Object.values(FeatureKey).filter((key) => isSocialCommerceModule(key));
}
